module.exports = __webpack_public_path__ + "img/logotel_pot_w.20a705de.png";